var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-footer-container"},[_c('p',[_vm._v(_vm._s(_vm.$t('footer.all_rights_reserved'))+" @2020")])])
}
var staticRenderFns = []

export { render, staticRenderFns }